export default __webpack_public_path__ + "static/media/KGZ.4eee8354.svg";